import React from 'react';
import { Box, Container, Theme } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

export type IconPaperProps = {
  className?: string;
  description?: React.ReactNode;
  children: React.ReactNode;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '888px',
      paddingBottom: theme.spacing(4),
      background: '#ffffff',
      boxShadow: '0px 16px 32px #00000014',
      '&:before': {
        content: '""',
        display: 'block',
        height: '6px',
        background: `transparent linear-gradient(90deg, ${theme.palette.themeColor.gradationBegin} 0%, ${theme.palette.themeColor.gradationEnd} 100%) 0% 0% no-repeat padding-box`,
      },
    },
    description: {
      marginTop: theme.spacing(4),
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      textAlign: 'center',
      '& span': { display: 'block' },
    },
    iconArea: {
      textAlign: 'center',
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
      [theme.breakpoints.up('md')]: {
        marginBottom: theme.spacing(2),
      },
    },
    icon: {
      verticalAlign: 'top',
      height: '64px',
      width: '64px',
    },
  }),
);

export const IconPaper: React.FC<IconPaperProps> = ({
  className = '',
  description,
  children,
}) => {
  const classes = useStyles();
  const imgSrc = `${process.env.PUBLIC_URL}/images/icon-project-room.png`;
  const imgAlt = 'Project Room Icon';

  return (
    <Container
      disableGutters
      maxWidth={false}
      className={`${classes.root} ${className}`}
    >
      {description && <Box className={classes.description}>{description}</Box>}
      <Box className={classes.iconArea}>
        <img src={imgSrc} alt={imgAlt} className={classes.icon} />
      </Box>
      {children}
    </Container>
  );
};
